import { Component, OnInit, OnChanges, Input, SimpleChange, SimpleChanges } from '@angular/core';
import { Params, Router } from '@angular/router';
import { Location } from '@angular/common';

import { CallService } from '../services/calls/call.service';
import { Call } from '../classes/call';
import { ReportService } from '../services/reports/report.service';

import { ProviderService } from '../services/providers/provider.service';



import * as moment from 'moment';



import * as _ from 'lodash';

@Component({
    moduleId: module.id,
    selector: 'status-calls',
    templateUrl: 'statusCalls.component.html',
    styleUrls: ['../users/users.component.css']
})

export class StatusCallsComponent implements OnInit, OnChanges {


    constructor(protected callService: CallService,
        protected location: Location,
        protected router: Router,
        protected infoService: ReportService,
        protected providerService: ProviderService) {
    }

    loadingInfo: boolean = true

    infoName = 'status'
    @Input() providers: any[] = []
    provider: any = {

    }

    fromDate: Date;
    toDate: Date
    from: string
    to: string
    calls: any[];
    info: number[] = []//= [0,0,0,0,0,0,0,0,0]
    labels: string[] = []//= ['CALLING', 'ACCEPTED', 'ENDED', 'ENDED_PATIENT', 'ENDED_DOCTOR', 'REJECTED', 'CANCELED', 'TIMEOUTED', 'EXPIRED']

    // chart
    public doughnutChartType: string = 'doughnut';
    public pieChartType: string = 'pie';
    public chartType: string = 'doughnut';
    public chartClicked(e: any): void {
        //console.log(e);
    }
    public chartHovered(e: any): void {
        //console.log(e);
    }

    ngOnInit(): void {
        let now = moment()
        let month = now.format('01' + '-MM-YYYY')
        this.from = month
        this.to = now.format('DD-MM-YYYY')
        //this.getInfo()
        this.loadingInfo = false
        //this.getProviders()
        //this.getInfo(false)
    }

    ngOnChanges(changes:SimpleChanges){
        if (changes["providers"].currentValue!=undefined) {
            this.loadingInfo = false
            this.provider = {id:0,name:"All"}
        }
      }

    getProviders() {
        this.providerService.get().then((providers) => {
            this.providers = providers
            this.loadingInfo = false
            this.providers.push({id:0,name:"All"})
            this.provider = {id:0,name:"All"}

        })
    }

    selectProvider(provider) {
        this.provider = provider
    }


    getInfo(useProvider) {

        let options = {
            from: this.from, 
            to: this.to
        }
        if (useProvider) options["provider"]=this.provider.id

        this.loadingInfo = true;
        this.infoService.getDashboardInfo(options, this.infoName).then((response) => {
            this.calls = response
            this.info = []
            this.labels = []
            var total = 0;
            for (var element in response) {
                total+=response[element];
            }
            for (var key in response) {
                let percentage = Math.round((response[key]*100)/total)
                this.labels.push(key+" "+percentage+"%")
                this.info.push(response[key])
            }
            this.loadingInfo = false;
            this.prepareChart()
        })
    }

    prepareChart() {

        
        //Hago esto porque sino no se actualiza el grafico
        try {
            let clone = JSON.parse(JSON.stringify(this.info));
            //clone = this.info;
            this.info = clone;

            clone = JSON.parse(JSON.stringify(this.labels));
            //clone = this.labels;
            this.labels = clone;

        }
        catch (err) {
            console.log("Atrapo un error que salta pero no afecta")
        }
        
    }

    changeType() {
        if (this.chartType == this.pieChartType) this.chartType = this.doughnutChartType
        else this.chartType = this.pieChartType

    }

    filter() {
        this.loadingInfo = true;
        if (this.fromDate !=undefined)this.from = moment(this.fromDate, 'YYYY-MM-DD').format('DD-MM-YYYY')
        if (this.toDate !=undefined) this.to = moment(this.toDate, 'YYYY-MM-DD').format('DD-MM-YYYY')
        let useProvider = this.provider.id!=0
        this.getInfo(useProvider)
    }
}


// WEBPACK FOOTER //
// ./src/app/calls/statusCalls.component.ts